



































import Vue, { PropType } from "vue"
import PCardList from "./local/PCardList.vue"
import PCardListItem from "./local/PCardListItem.vue"
import CInfiniteScrollList from "~/components/custom/baseList/CInfiniteScrollList.vue"
import EmptyNotifier from "~/components/guideline/notice/EmptyNotifier.vue"
import { ProjectView, decorateProjectView } from "~/backendApis/viewModel"

export interface ClickFavoriteIconEmitArgument {
  projectId: string
}

export default Vue.extend({
  components: {
    PCardList,
    PCardListItem,
    CInfiniteScrollList,
    EmptyNotifier,
  },
  props: {
    projects: {
      type: Array as PropType<ProjectView[]>,
      required: true,
    },
    enableFavorite: {
      type: Boolean,
      required: true,
    },
    favoriteProjectIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    isFetchableNext: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isNotExistsProjects(): boolean {
      return this.projects.length === 0
    },
  },
  methods: {
    featureTexts(project: ProjectView): string[] {
      return decorateProjectView(project).featureTexts()
    },
    isClosedApplication(project: ProjectView): boolean {
      return decorateProjectView(project).isClosedApplication()
    },
    handleClickFavoriteIcon(projectId: string) {
      const arg: ClickFavoriteIconEmitArgument = {
        projectId,
      }
      this.$emit("click-favorite-icon", arg)
    },
    isFavoriteProject(projectId: string): boolean {
      return this.favoriteProjectIds.includes(projectId)
    },
    getMonthDate(project: ProjectView): string {
      return decorateProjectView(project).getMonthDate()
    },
    handleTouchBottom() {
      this.$emit("handle-touch-bottom")
    },
    getHeaderImageLargeJobCategoryId(project: ProjectView): number {
      return decorateProjectView(project).getHeaderImageLargeJobCategoryId()
    },
    getHeaderImagePatternNo(project: ProjectView): number {
      return decorateProjectView(project).getHeaderImagePatternNo()
    },
  },
})
